// ミツカン便り コメント機能
// 投稿は記事ごとに累計3回まで（ミツカンchと同仕様）。ポイントは1記事につき初回コメントのみ10pt、画像付きは20pt（バックエンドが get_point で返す）

const MIZKAN_DAYORI_CROP_RATIO = 1;   // トリミング比率（幅:高さ）。暫定1:1
const MIZKAN_DAYORI_MAX_EDGE = 1080;  // トリミング後の長辺上限(px)
const MIZKAN_DAYORI_MAX_FILE_MB = 10; // ファイルサイズ上限(MB)

let mizkanDayoriCommentImageData = null; // 送信用のトリミング済みbase64（未選択時はnull）

document.addEventListener("DOMContentLoaded", function () {
    const commentElement = document.querySelector(".daily_pad_calendar_comment");
    const commentPlane = document.querySelector(".daily_pad_calendar_send_plane");
    const commentArea = document.querySelector("#comment-content");
    const commentWrapper = document.querySelector("#daily_pad_calendar_comment_wrapper");
    const commentForm = document.querySelector("#article-comment-form");
    if (!commentElement) return;
    commentElement.addEventListener("click", function (event) {
        if (event.currentTarget.classList.contains("logout")) {
            window.theme.openModal('#modal_login_appeal');
            return;
        }
    })
    if (!commentPlane) return;
    commentPlane.addEventListener("click", function (event) {
        event.stopPropagation();
        if (!commentArea || !commentWrapper || !commentForm || commentWrapper.value.trim() == "") return;
        const commentSubmit = commentForm.querySelector("input[type='submit']");
        if (!commentSubmit) return;
        commentArea.value = commentWrapper.value;
        checkNGWordAndSubmit();
    })
});

async function checkNGWordAndSubmit() {
    const commentContent = document.getElementById("comment-content").value;
    const commentBox = document.querySelector('#comment-box');
    const articleId = commentBox.getAttribute('article-id');
    const customerId = commentBox.getAttribute('customer-id');
    const author = document.getElementById("comment-author").value;
    const email = document.getElementById("comment-email").value;
    const blogId = commentBox.getAttribute('blog-id');

    // 絵文字を判別する正規表現
    const emojiPattern = /[\u{1F600}-\u{1F64F}\u{1F680}-\u{1F6FF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}\u{1F1E0}-\u{1F1FF}\u{1F900}-\u{1F9FF}\u{1FA70}-\u{1FAFF}\u{1F300}-\u{1F5FF}\u{1F700}-\u{1F77F}\u{1F780}-\u{1F7FF}\u{1F800}-\u{1F8FF}\u{1F900}-\u{1F9FF}\u{1FA00}-\u{1FA6F}\u{1FA70}-\u{1FAFF}\u{1FB00}-\u{1FBFF}\u{1FC00}-\u{1FCFF}\u{1FD00}-\u{1FDFF}\u{1FE00}-\u{1FEFF}\u{1FF00}-\u{1FFFF}]/gu;

    const displayControlContent = ["mizkan-ch__article", "comment-container"];
    if (emojiPattern.test(commentContent)) {
        document.querySelector('.profanity-warning').removeAttribute('hidden');
        document.querySelector('.profanity-warning').textContent = '絵文字はご利用いただけません。';
        document.querySelector('.cooklist_loading_container').style.display = 'none';
        displayControlContent.forEach((content) => {
            document.querySelector(`.${content}`).hidden = false;
        });

        const element = document.querySelector('.profanity-warning');
        const headerOffset = 150;
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.scrollY - headerOffset;

        window.scrollTo({
            top: offsetPosition,
            behavior: "smooth"
        });
        return;
    } else {
        document.querySelector('.profanity-warning').setAttribute('hidden', '');
    }

    document.querySelector('.cooklist_loading_container').style.display = 'block';
    displayControlContent.forEach((content) => {
        document.querySelector(`.${content}`).hidden = true;
    });

    try {
        const params = {
            article_id: articleId,
            blog_id: blogId,
            body: commentContent,
            author: author,
            email: email
        };
        if (mizkanDayoriCommentImageData) {
            params.image_data = mizkanDayoriCommentImageData;
        }
        const response = await fetch(`${window.AppProxyPath}/api/customers/mizkan-dayori/comment?logged_in_customer_id=${customerId}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(params),
        });
        const data = await response.json();

        if (!data.success) {
            document.querySelector('.cooklist_loading_container').style.display = 'none';
            document.body.style.overflow = 'auto';
            displayControlContent.forEach((content) => {
                document.querySelector(`.${content}`).hidden = false;
            });

            switch (data.error_code) {
                case 'COMMENT_LIMIT_REACHED': {
                    document.querySelector('.profanity-warning').removeAttribute('hidden');
                    document.querySelector('.profanity-warning').textContent = '投稿は記事ごとに3回までとなります。';
                    const limitElement = document.querySelector('.profanity-warning');
                    const limitHeaderOffset = 150;
                    const limitElementPosition = limitElement.getBoundingClientRect().top;
                    const limitOffsetPosition = limitElementPosition + window.scrollY - limitHeaderOffset;
                    window.scrollTo({
                        top: limitOffsetPosition,
                        behavior: "smooth"
                    });
                    return;
                }
                case 'NG_WORD_DETECTED':
                    open_modal_ng('#modal_input_error');
                    return;
                case 'UNAUTHORIZED':
                    window.theme.openModal('#modal_login_appeal');
                    return;
                default:
                    open_modal_error('#error_modal');
                    return;
            }
        }

        // 初回コメントのポイント付与（get_point=10、画像付きは20）はリロード後にモーダル表示する
        if (Number(data.get_point) > 0) {
            localStorage.setItem('mizkan_dayori_comment_point', data.get_point);
        }
        window.location.reload();
    } catch (error) {
        console.error('Error:', error);
        document.querySelector('.cooklist_loading_container').style.display = 'none';
        document.body.style.overflow = 'auto';
        displayControlContent.forEach((content) => {
            document.querySelector(`.${content}`).hidden = false;
        });
        open_modal_error('#error_modal');
    }
}

function open_modal_ng(id_modal) {
    // モーダルを閉じる
    document.querySelector('#modal_input_error button').addEventListener('click', function () {
        document.querySelector('#modal_input_error').classList.remove('open');
    })

    // モーダル表示
    document.querySelector('#modal_input_error').classList.add('open');
}

async function loadComments(cursor = null) {
    try {
        let article_id = document.querySelector('#comment-box').getAttribute('article-id');
        let url = `${window.AppProxyPath}/api/customers/mizkan-dayori/get-comments/${article_id}`;

        const deletedCommentId = sessionStorage.getItem('deletedCommentId');

        const params = new URLSearchParams();
        if (cursor) params.append('cursor', cursor);
        if (deletedCommentId) params.append('deletedCommentId', deletedCommentId);

        if (params.toString()) {
            url += `?${params.toString()}`;
        }

        const result = await fetch(url, {
            method: 'get',
            headers: {
                'Content-Type': 'application/json'
            }
        });
        const res = await result.json();
        if (res.comments) {
            if (!res.pageInfo.hasNextPage) {
                const showMoreButton = document.querySelector('#showMoreComments');
                if (showMoreButton) showMoreButton.remove();
            } else {
                document.querySelector('#showMoreComments').setAttribute('cursor', res.pageInfo.endCursor);
            }
            res.comments.forEach(comment_data => {
                const commentItem = createCommentItem(comment_data);
                document.querySelector('#comment-box').appendChild(commentItem);
            });
        }
    } catch (error) {
        console.error('Failed to load comments:', error);
        const showMoreButton = document.querySelector('#showMoreComments');
        if (showMoreButton) showMoreButton.setAttribute('hidden', true);
    } finally {
        document.querySelector('.comment-loading').classList.remove('is-loading');
    }
}

function createCommentItem(comment_data) {
    const commentItem = document.createElement('div');
    commentItem.classList.add('mizkan__top__main__comment-item');

    const authorIcon = document.createElement('img');
    // ドメインに基づいて異なるアイコンURLを設定
    let defaultIconUrl;
    if (window.location.hostname === '365.mizkan.co.jp') {
        defaultIconUrl = '//365.mizkan.co.jp/cdn/shop/files/user_icon_1.png';
    } else {
        defaultIconUrl = '//dev-365.myshopify.com/cdn/shop/files/user_icon_1.png';
    }
    authorIcon.classList.add('author-icon');
    const authorIconUrl = comment_data.author.usericon || defaultIconUrl;
    authorIcon.src = authorIconUrl;
    authorIcon.alt = comment_data.author.nickname + "のアイコン";
    const authorIconBgColor = comment_data.author.user_icon_bg_color || '#fff';
    authorIcon.style.backgroundColor = authorIconBgColor;
    commentItem.appendChild(authorIcon);

    const textBox = document.createElement('div');
    textBox.classList.add('mizkan__top__main__comment__text-box');
    commentItem.appendChild(textBox);

    const name = document.createElement('span');
    name.classList.add('name');
    name.textContent = comment_data.author.nickname;
    textBox.appendChild(name);

    const commentContent = document.createElement('p');
    commentContent.classList.add('comment-content');
    commentContent.textContent = comment_data.content;
    textBox.appendChild(commentContent);

    if (comment_data.image_url) {
        const commentImage = document.createElement('img');
        commentImage.classList.add('mizkan-dayori-comment__image');
        commentImage.src = comment_data.image_url;
        commentImage.alt = comment_data.author.nickname + "の投稿画像";
        commentImage.loading = 'lazy';
        textBox.appendChild(commentImage);
    }

    if (String(comment_data.author.customer_id) === document.querySelector('#comment-box').getAttribute('customer-id')) {
        const removeButton = document.createElement('div');
        removeButton.classList.add('daily_pad_calendar_comment_remove');
        const removeSpan = document.createElement('span');
        removeSpan.classList.add('daily_pad_calendar_comment_remove_span');
        removeSpan.textContent = '削除する';
        removeButton.appendChild(removeSpan);

        removeButton.setAttribute('data-comment-id', comment_data.id);
        removeButton.setAttribute('data-customer-id', comment_data.author.customer_id);

        textBox.appendChild(removeButton);
    }
    return commentItem;
}

document.addEventListener("DOMContentLoaded", function () {
    const commentBox = document.querySelector('#comment-box');
    if (!commentBox) return;

    document.querySelector('.comment-loading').classList.add('is-loading');
    const delete_modal_block = document.querySelector('div.delete_modal_block');
    let comment_id;
    let customer_id;
    document.addEventListener('click', async function (event) {
        let targetElement = event.target;

        if (targetElement.classList.contains('daily_pad_calendar_comment_remove_span')) {
            targetElement = targetElement.parentElement;
        }

        switch (targetElement.className) {
            case 'daily_pad_calendar_comment_remove':
                delete_modal_block.style.display = 'flex';
                comment_id = targetElement.dataset.commentId;
                customer_id = targetElement.dataset.customerId;
                break;
            case 'delete_button_no':
                delete_modal_block.style.display = 'none';
                comment_id = null;
                customer_id = null;
                break;
            case 'delete_button_yes':
                delete_modal_block.style.display = 'none';
                if (!comment_id) break;
                const currentCommentId = comment_id;
                const params = JSON.stringify({
                    "comment_id": currentCommentId,
                    "customer_id": customer_id
                });
                let url = window.AppProxyPath + '/api/customers/mizkan-dayori/comment/remove';
                document.querySelector('.cooklist_loading_container').style.display = 'block';
                const displayControlContent = ["mizkan-ch__article", "comment-container"];
                displayControlContent.forEach((content) => {
                    document.querySelector(`.${content}`).hidden = true;
                });
                fetch(url, {
                    method: 'post',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: params
                })
                    .then(response => {
                        if (response.ok) {
                            return response.json().then(data => {
                                sessionStorage.setItem('deletedCommentId', currentCommentId);
                                setTimeout(function () {
                                    window.location.reload();
                                }, 3500);
                            });
                        } else if (response.status !== 404) {
                            throw new Error('Server or client error');
                        }
                    })
                    .catch(error => {
                        console.error('Error:', error);
                        open_modal_error('#error_modal');
                        document.querySelector('.cooklist_loading_container').style.display = 'none';
                        displayControlContent.forEach((content) => {
                            document.querySelector(`.${content}`).hidden = false;
                        });
                    });
                comment_id = null;
                customer_id = null;
                break;
        }
    });

    var showMoreButton = document.getElementById("showMoreComments");
    setTimeout(function () {
        loadComments();
        showMoreButton.disabled = false;
    }, 4000);

    // ボタン「コメントをもっと見る」押下時
    showMoreButton.addEventListener("click", async function () {
        const cursor = showMoreButton.getAttribute('cursor');
        if (cursor) {
            showMoreButton.disabled = true;
            await loadComments(cursor);
            showMoreButton.disabled = false;
        }
    });

    // コメントが0件のときはみんなのコメント以下を非表示にする
    if (commentBox.getAttribute('comments-count') === '0') {
        commentBox.style.display = 'none';
    }
});

// コメント投稿ポイント（1記事につき初回のみ10pt、画像付きは20pt）の獲得モーダルをリロード後に表示
window.addEventListener('load', function () {
    const comment_point = localStorage.getItem('mizkan_dayori_comment_point');
    if (comment_point) {
        if (Number(comment_point) > 0) {
            document.dispatchEvent(new CustomEvent('customer:point:earn', { detail: { point: Number(comment_point), item: 'ミツカン便りへのコメント投稿完了！', description: '1記事1コメントのみポイント獲得可能' } }));
        }
        localStorage.removeItem('mizkan_dayori_comment_point');
    }
});

// 改行入力に合わせて入力欄の高さを自動調整（送信は紙飛行機ボタンのみ。Enterは改行）
document.addEventListener('DOMContentLoaded', function () {
    var textarea = document.getElementById('daily_pad_calendar_comment_wrapper');
    if (!textarea) return;
    var minTextareaHeight = 0;
    var measureClone = null;
    var lastMeasuredWidth = 0;
    var autoResizeTextarea = function () {
        if (!textarea.offsetWidth) return;
        textarea.style.height = 'auto';
        textarea.style.height = Math.max(textarea.scrollHeight, minTextareaHeight) + 'px';
    };
    var measureMinTextareaHeight = function () {
        if (!textarea.offsetWidth) return;
        if (!measureClone) {
            measureClone = document.createElement('textarea');
            measureClone.className = textarea.className;
            measureClone.rows = textarea.rows;
            measureClone.tabIndex = -1;
            measureClone.setAttribute('aria-hidden', 'true');
            measureClone.style.cssText = 'position:absolute; visibility:hidden; left:-9999px; top:0; height:auto;';
            textarea.parentNode.appendChild(measureClone);
        }
        var computed = getComputedStyle(textarea);
        ['width', 'boxSizing', 'paddingTop', 'paddingRight', 'paddingBottom', 'paddingLeft',
            'borderTopWidth', 'borderRightWidth', 'borderBottomWidth', 'borderLeftWidth',
            'fontFamily', 'fontSize', 'fontWeight', 'fontStyle', 'letterSpacing', 'lineHeight',
            'whiteSpace', 'wordBreak'].forEach(function (prop) {
            measureClone.style[prop] = computed[prop];
        });
        measureClone.value = textarea.placeholder;
        minTextareaHeight = measureClone.scrollHeight;
        lastMeasuredWidth = window.innerWidth;
        autoResizeTextarea();
    };
    textarea.addEventListener('input', autoResizeTextarea);
    var autoResizeTimer;
    window.addEventListener('resize', function () {
        clearTimeout(autoResizeTimer);
        autoResizeTimer = setTimeout(function () {
            if (window.innerWidth === lastMeasuredWidth) return;
            measureMinTextareaHeight();
        }, 150);
    });
    if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(measureMinTextareaHeight);
    }
    measureMinTextareaHeight();
});

// 画像アップロード（1コメント1枚 / 自動中央トリミング + 長辺リサイズ）
document.addEventListener('DOMContentLoaded', function () {
    const fileInput = document.getElementById('commentImageInput');
    const preview = document.getElementById('commentImagePreview');
    const previewImg = document.getElementById('commentImagePreviewImg');
    const previewRemove = document.getElementById('commentImagePreviewRemove');
    const previewFileName = document.getElementById('commentImageFileName');
    const previewFileMeta = document.getElementById('commentImageFileMeta');
    if (!fileInput) return;

    previewRemove.addEventListener('click', function () {
        clearCommentImage();
    });

    fileInput.addEventListener('change', function (e) {
        const file = e.target.files[0];
        if (!file) return;

        const filesize = (file.size / (1000 * 1000)).toFixed(1); // MB
        if (filesize > MIZKAN_DAYORI_MAX_FILE_MB) {
            open_modal_error('#file_size_error_modal');
            fileInput.value = '';
            return;
        }

        const extension = file.name.split('.').pop().toLowerCase();
        let filePromise;
        if (extension === 'heic') {
            // PCのブラウザはheicを表示不可のためJPEGへ変換（既存パターン踏襲）
            filePromise = heic2any({
                blob: file,
                toType: 'image/jpeg',
            });
        } else {
            filePromise = Promise.resolve(file);
        }

        filePromise
            .then((blob) => {
                return new Promise((resolve, reject) => {
                    const img = new Image();
                    const objectUrl = URL.createObjectURL(blob);
                    img.onload = () => {
                        URL.revokeObjectURL(objectUrl);
                        resolve(img);
                    };
                    img.onerror = reject;
                    img.src = objectUrl;
                });
            })
            .then((img) => {
                mizkanDayoriCommentImageData = cropAndResizeCommentImage(img);
                previewImg.src = mizkanDayoriCommentImageData;
                previewFileName.textContent = truncateCommentFileName(file.name);
                previewFileName.title = file.name;
                previewFileMeta.textContent = formatCommentFileMeta(file);
                preview.hidden = false;
            })
            .catch((error) => {
                console.error('Failed to process image:', error);
                clearCommentImage();
                open_modal_error('#error_modal');
            });
    });

    function clearCommentImage() {
        fileInput.value = '';
        mizkanDayoriCommentImageData = null;
        previewImg.src = '';
        previewFileName.textContent = '';
        previewFileName.removeAttribute('title');
        previewFileMeta.textContent = '';
        preview.hidden = true;
    }
});

// 長いファイル名は中央を省略して拡張子側を残す（例: 夏の冷たい麺アレンジ…シピ.png）
function truncateCommentFileName(name, maxLength = 24) {
    const chars = Array.from(name); // サロゲートペアを分断しないようcode point単位で扱う
    if (chars.length <= maxLength) return name;
    const head = chars.slice(0, Math.ceil((maxLength - 1) / 2)).join('');
    const tail = chars.slice(-Math.floor((maxLength - 1) / 2)).join('');
    return `${head}…${tail}`;
}

// 添付カードに表示する「種類・サイズ」（例: PNG・2.4MB）
function formatCommentFileMeta(file) {
    const extension = file.name.includes('.') ? file.name.split('.').pop().toUpperCase() : '';
    const mb = file.size / (1000 * 1000);
    const size = mb >= 1 ? `${mb.toFixed(1)}MB` : `${Math.max(1, Math.round(file.size / 1000))}KB`;
    return extension ? `${extension}・${size}` : size;
}

// 中央を固定比率で切り出し、長辺が上限を超える場合は縮小してbase64を返す
function cropAndResizeCommentImage(img) {
    let cropWidth = img.width;
    let cropHeight = cropWidth / MIZKAN_DAYORI_CROP_RATIO;
    if (cropHeight > img.height) {
        cropHeight = img.height;
        cropWidth = cropHeight * MIZKAN_DAYORI_CROP_RATIO;
    }
    const sx = (img.width - cropWidth) / 2;
    const sy = (img.height - cropHeight) / 2;

    const scale = Math.min(1, MIZKAN_DAYORI_MAX_EDGE / Math.max(cropWidth, cropHeight));
    const canvas = document.createElement('canvas');
    canvas.width = Math.round(cropWidth * scale);
    canvas.height = Math.round(cropHeight * scale);
    canvas.getContext('2d').drawImage(img, sx, sy, cropWidth, cropHeight, 0, 0, canvas.width, canvas.height);

    return canvas.toDataURL('image/jpeg', 0.85);
}
